'use client';

import { IceJiLogo } from '@components/logo/IceJi';
import { app } from '@config';
import { motion } from 'framer-motion';
import Image from 'next/image';
import type { RefObject } from 'react';
import { Engine } from './engine';
import { Footer } from './footer';
import { SocialContact } from './social';
export const AppInfoModal = ({
  $ref,
  _onClearModal
}: {
  $ref: RefObject<HTMLDivElement | null>;
  _onClearModal: () => void;
}) => {
  return <motion.div animate={{
    y: 0
  }} className='flex h-[220px] w-[339px] overflow-hidden rounded-lg bg-white p-2 drop-shadow-xl md:h-[500px] md:w-[750px] md:p-4 dark:bg-[#171717]' exit={{
    y: '80%'
  }} initial={{
    y: '80%'
  }} ref={$ref} transition={{
    duration: 0.8,
    ease: [0.6, 0.05, 0.01, 0.9]
  }}>
      <div className='flex h-full flex-grow flex-col items-start justify-between p-1 md:p-4'>
        <div className='flex h-9 w-full items-center md:h-[57px]'>
          <div className='mr-2 h-full w-[38px] rounded-lg bg-primary p-1 md:w-[57px] md:p-2.5'>
            <IceJiLogo />
          </div>
          <div>
            <h2 className='font-semibold text-xs md:text-xl'>
              TheIceJi Cosmos
            </h2>
            <p className='font-light text-2xs leading-3 md:text-xs'>
              Ver {app.VERSION} | {app.UPDATE_DATE}
            </p>
          </div>
        </div>
        <div className='font-light text-2xs leading-3 md:text-base md:leading-5'
      // onClick={_onClearModal}
      >
          <p className='font-medium'>Engine:</p>
          <Engine />
          <p className='mt-1 font-medium md:mt-2'>Contact:</p>
          <SocialContact />
        </div>
        <div className='flex h-3 w-[90px] space-x-2 md:h-6 md:w-[180px]'>
          <Footer />
        </div>
      </div>
      <div className='relative h-full w-[130px] overflow-hidden rounded-lg md:w-[415px]'>
        <Image alt='TheIceJi Splash Screen' blurDataURL={'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='}
      // width={1500}
      // height={3000}
      className='h-full duration-300 hover:scale-110 hover:duration-150' fill objectFit='cover' placeholder='blur' src='/layout/appInfo/4.jpg' />
      </div>
    </motion.div>;
};